import React from 'react';
import { twMerge } from 'tailwind-merge';

export function IconResetArrows({ onClick, className, color = '#4318FF' }) {
  return (
    <svg
      onClick={onClick}
      className={twMerge(' w-6 h-6 group', className)}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8588 14.5714L12.0017 18.4285L15.8588 22.2857M8.14453 9.42852L12.0017 5.57138L8.14453 1.71423"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M12.0022 18.4286H19.7165C20.6258 18.4286 21.4979 18.0673 22.1409 17.4243C22.7839 16.7814 23.1451 15.9093 23.1451 15V8.99998C23.1451 8.09067 22.7839 7.2186 22.1409 6.57562C21.4979 5.93263 20.6258 5.57141 19.7165 5.57141H17.1451M12.0022 5.57141H4.28795C3.37863 5.57141 2.50656 5.93263 1.86358 6.57562C1.2206 7.2186 0.859375 8.09067 0.859375 8.99998V15C0.859375 15.9093 1.2206 16.7814 1.86358 17.4243C2.50656 18.0673 3.37863 18.4286 4.28795 18.4286H6.85938"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}
